import { Box, Button as MuiButton, styled, useMediaQuery } from '@mui/material';
import React from 'react';
import RemoveIcon from '../../assets/icon/remove-icon';
import AddIcon from '../../assets/icon/add-icon';
import theme from '../../config/theme';
import constants from '../../config/constants';

type PropsTypes = {
  section: 'exterior-web' | 'exterior-mobile' | 'interior' | 'gallery';
  handleClickZoom: () => void;
  zoomStep?: number;
  handleClickZoomIn?: () => void | undefined;
  handleClickZoomOut?: () => void | undefined;
  isZoomEnabled?: boolean;
};

const Button = styled(MuiButton)<any>(({ name, orientation }) => ({
  position: 'initial',
  '&:hover': {
    background: 'rgba( 0, 0, 0, 0.8 )',
  },
  '&.Mui-disabled': {
    '&:hover': {
      background: 'rgba( 0, 0, 0, 0.6 )',
    },
    '&>svg': {
      color: 'rgba(255, 255, 255, 0.5)',
    },
    background: 'rgba( 0, 0, 0, 0.5 )',
  },
  cursor: 'pointer',
  backgroundColor: '#1E1E1E82',
  borderRadius:
    name === 'zoom-in' && orientation === 'portrait'
      ? '25px 25px 0 0'
      : name === 'zoom-out' && orientation === 'portrait'
      ? '0 0 25px 25px'
      : name === 'zoom-in' && orientation === 'landscape'
      ? '0 25px 25px 0'
      : '25px 0 0 25px',
  background: constants.BLUR_STYLE.background,
  backdropFilter: constants.BLUR_STYLE.filter,
  [theme.breakpoints.up('lg')]: {
    padding: orientation === 'portrait' ? '1.4rem 1.1rem' : '1rem 1.2rem',
  },
  [theme.breakpoints.down('lg')]: {
    padding: orientation === 'portrait' ? '0.5rem 0' : '0.3rem 0',
    minWidth: '30px',
    '&>svg': {
      fontSize: '1rem',
    },
  },
  borderBottom: '1px solid #222',
}));

export default function ZoomButton(props: PropsTypes) {
  const {
    handleClickZoom,
    section,
    zoomStep,
    handleClickZoomIn,
    handleClickZoomOut,
    isZoomEnabled,
  } = props;

  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));

  const isPortrait = useMediaQuery('(orientation: portrait)');
  const isLandscape = useMediaQuery('(orientation: landscape)');

  let orientation;

  switch (section) {
    case 'exterior-web':
      orientation = 'portrait';
      break;
    case 'exterior-mobile':
      orientation = 'landscape';
      break;
    case 'interior':
      orientation = 'portrait';
      break;
    case 'gallery':
      orientation = 'landscape';
      break;
    default:
      console.log('Error: orientation detection by section has error');
      break;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: orientation === 'portrait' ? 'column' : 'row-reverse',
        position:
          section === 'exterior-mobile'
            ? 'initial'
            : zoomStep && zoomStep === 1
            ? 'absolute'
            : section === 'exterior-web' || (zoomStep && zoomStep === 1)
            ? 'initial'
            : 'fixed',
        top: section === 'gallery' ? 'unset' : '50%',
        left: zoomStep === 1 ? 'unset' : section === 'gallery' ? '50%' : '1rem',
        width: zoomStep === 1 ? '100%' : 'auto',
        bottom:
          section === 'gallery' &&
          zoomStep &&
          zoomStep === 1 &&
          isMobile &&
          isPortrait
            ? '10%'
            : section === 'gallery' &&
              zoomStep &&
              zoomStep === 1 &&
              isMobile &&
              isLandscape
            ? 0
            : section === 'gallery' && zoomStep && zoomStep === 2
            ? '0.7rem'
            : section === 'gallery' && zoomStep && zoomStep === 1
            ? '1rem'
            : 'unset',
        transform:
          zoomStep === 2
            ? 'translate(-50%, -50%)'
            : section === 'gallery' || section === 'interior'
            ? 'translate(0%, -50%)'
            : 'initial',
      }}
    >
      <Button
        disabled={isZoomEnabled}
        name="zoom-in"
        onClick={handleClickZoomIn || handleClickZoom}
        orientation={orientation}
      >
        <AddIcon sx={{ color: 'white', fontSize: '1.5rem' }} />
      </Button>
      <Button
        disabled={!isZoomEnabled}
        name="zoom-out"
        onClick={handleClickZoomOut || handleClickZoom}
        orientation={orientation}
        variant="contained"
      >
        <RemoveIcon
          fill={'white'}
          sx={{ color: 'white', fontSize: '1.5rem' }}
        />
      </Button>
    </Box>
  );
}
